import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpEventType } from '@angular/common/http';
import { Router } from '@angular/router';
import { InventoryItemFactory } from 'src/app/factories/inventory-item.factory';
import { ConnectionService } from 'src/app/services/connection.service';
import { EbayService } from 'src/app/services/ebay.service';
import { MediaService } from 'src/app/services/media.service';
import { InventoryService } from 'src/app/services/inventory.service';
import { Clipboard } from '@angular/cdk/clipboard';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';
import { Media } from '@contracts/interfaces/media.interfaces';
import { InventoryCategoryService } from '../../services/inventory-category.service';
import { InventoryCategory } from '@contracts/interfaces/inventory-category';


@Component({
  selector: 'ap-inventory-item-template-dialog',
  templateUrl: 'inventory-item-template.dialog.html',
  styleUrls: ['./inventory-item-template.dialog.scss', '../common-dialog-styles.scss']
})
export class InventoryItemTemplateDialogComponent implements OnInit {

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialog: MatDialog,
      private router: Router,
      private inventoryService: InventoryService,
      public inventoryCategoryService: InventoryCategoryService,
      private connectionService: ConnectionService,
      private ebayService: EbayService,
      private clipboard: Clipboard
      ) {
        this.inventoryCategoryService.find({}).subscribe((categories: InventoryCategory[]) => {
          this.categories = categories;
          this.load(data.categoryID)
        })
      }

      public tab = "features";

      public Editor = ClassicEditor;

      public categories: InventoryCategory[] = [];
    
      public isLoaded = false;
      public category: InventoryCategory;
    
      public template: any;
    
      ngOnInit(): void {


      }
    
      load (categoryID: number) {
   
        this.inventoryCategoryService.get(categoryID).subscribe((category: InventoryCategory) => {
          this.category = category;
          this.template = category.itemTemplate;
          this.isLoaded = true;
          console.log(this.category)
        })

        // this.inventoryService.getItemTypes(categoryName).subscribe((r: any) => {
        //   if (r.length != 0) {
        //     this.template = r[0].itemTemplate;

        //     this.isLoaded = true
        //   }
        // });
      }
    
      changeTypes(type: string) {
        this.router.navigate(["settings", "item-template-editor", type])
      }
    
      save() {
        this.category.itemTemplate = this.template;

        this.inventoryCategoryService.updateCategory(this.category).subscribe(r => {
          console.log(r);
        });

        // this.inventoryService.updateItemTemplate(this.template).subscribe((r: any) => {
        //   console.log(r);
        // });
      }
    
      public descriptionOnBlur({ editor }: ChangeEvent) {
        let index = this.getTemplateIndex('ebay');
        
        const data = editor.getData();
    
        this.template[index].data.description = data;
        console.log(this.template)
        this.save();
      }
     
      getTemplate(name: string) {
        if (this.template != undefined) {
          for (let definition of this.template) {
            if (definition.component == name) {
              return definition;
            }
          }
        }
      }

      getTemplateIndex(name: string) {
        if (this.template != undefined) {
          for (let i = 0; i < this.template.length; i++) {
            if (this.template[i].component == name) {
              return i;
            }
          }
        }
      }

      hasTemplate(name: string) {
        if (this.template != undefined) {
          for (let definition of this.template) {
            if (definition.component == name) {
              return true;
            }
          }
        }

        return false;
      }

      deleteTemplate(name: string) {
        if (this.template != undefined) {
          for (let i=0; i < this.template.length; i++) {
            if (this.template[i].component == name) {
              this.template.splice(i, 1);
              this.save();
              this.tab = 'features'
            }
          }
        }

      }

      deleteComponent (index: number) {
        this.template.splice(index, 1);
        this.save();
      }
    
      copyComponent (index: number) {
        this.clipboard.copy(JSON.stringify(this.template[index].data));
      }
    
      pasteComponent (index: number) {
        navigator.clipboard.readText().then((text => {
          this.template[index].data = JSON.parse(text);
        })).catch(err => {
          console.error('Failed to read clipboard contents: ', err);
        });;
      }
      
      shownToolbars = [];
      show(index: number) {
        this.shownToolbars.push(index);
      }
    
      isHidden(index: number) {
        return this.shownToolbars.includes(index);
      }
    
      addEbay(index: number) {
        this.template.splice(index+1, 0, {
          component: "ebay",
          data: InventoryItemFactory.newEbay()
        });
    
        this.save();
        this.tab = 'ebay';
      }
    
      addEbayAspect() {
        let index = this.getTemplateIndex('ebay');

        if (this.template[index].data.aspects == undefined) {
          this.template[index].data.aspects = [];
        }
    
        this.template[index].data.aspects.push({
          label: "",
          value: ""
        });
    
        this.save();
      }
    
      saveEbayAspectLabel(aspectIndex: number, value: string) {
        let index = this.getTemplateIndex('ebay');

        this.template[index].data.aspects[aspectIndex].label = value;
        this.save();
      }
    
      saveEbayAspectValue(aspectIndex: number, value: string) {
        let index = this.getTemplateIndex('ebay');

        this.template[index].data.aspects[aspectIndex].value = value;
        this.save();
      }
    
      deleteEbayAspect(aspectIndex: number) {
        let index = this.getTemplateIndex('ebay');

        this.template[index].data.aspects.splice(aspectIndex, 1);
        this.save();
      }
    
      addFacebook(index: number) {
        this.template.splice(index+1, 0, {
          component: "facebook",
          data: InventoryItemFactory.newFacebook()
        });
    
        this.save();

        this.tab = 'facebook';
      }
    
      addWebflow(index: number) {
        this.template.splice(index+1, 0, {
          component: "webflow",
          data: InventoryItemFactory.newWebflow()
        });
    
        this.save();

        this.tab = 'webflow';
      }
       
      addFeature() {
        let index = this.getTemplateIndex('features');

        this.template[index].data.required.push({
          label: "",
          type: ""
        })
        this.save();
      }
    
      featureUp (featureIndex: number) {
        let index = this.getTemplateIndex('features');

        if (featureIndex > 0) {
          array_move(this.template[index].data.required, featureIndex, featureIndex-1);
          this.save();
        }
      }
    
      featureDown(featureIndex: number) {
        let index = this.getTemplateIndex('features');

        if (featureIndex < this.template[index].data.required.length - 1) {
          array_move(this.template[index].data.required, featureIndex, featureIndex+1);
          this.save();
        }
      }
    
      saveFeatureLabel(featureIndex: number, value: string) {
        let index = this.getTemplateIndex('features');

        this.template[index].data.required[featureIndex].label = value;
        this.save();
      }
    
      deleteFeature(featureIndex: number) {
        let index = this.getTemplateIndex('features');

        this.template[index].data.required.splice(featureIndex, 1);
        this.save();
      }
    
      addOptionFeature(featureIndex: number) {
        let index = this.getTemplateIndex('features');

        if (this.template[index].data.required[featureIndex].options == undefined) {
          this.template[index].data.required[featureIndex].options = [];
        }
        this.template[index].data.required[featureIndex].options.push("");
        this.save();
      }
    
      deleteOptionFeature(featureIndex: number, optionIndex: number) {
        let index = this.getTemplateIndex('features');

        this.template[index].data.required[featureIndex].options.splice(optionIndex, 1);
        this.save();
      }
    
      featureOptionUp(featureIndex: number, optionIndex: number) {
        let index = this.getTemplateIndex('features');

        array_move(this.template[index].data.required[featureIndex].options, optionIndex, optionIndex+1);
        this.save();
      }
    
      featureOptionDown(featureIndex: number, optionIndex: number) {
        let index = this.getTemplateIndex('features');

        array_move(this.template[index].data.required[featureIndex].options, optionIndex, optionIndex-1);
        this.save();
      }
    
      saveOption(featureIndex: number, optionIndex: number, value: string) {
        let index = this.getTemplateIndex('features');

        this.template[index].data.required[featureIndex].options[optionIndex] = value;
        this.save();
      }
    
      getItemVariables() {
        let variables = [];
        
        for (let definition of this.template) {
          if (definition.component == "features") {
            for (let feature of definition.data.required) {
              variables.push("{{item features '"+feature.label+"'}}")
            }
          }
        }
    
        return variables;
      }
    
      getPlaceholderImage(placeholder: string, placeholderPath: string) {
        return "url('" + this.connectionService.address + "/static-media/" + placeholderPath + "/" + placeholder + "')";
      }
    
      openImageEditor(placeholder: string, placeholderPath: string) {
    
        // this.mediaService.open(
        //   "/static-media/" + placeholderPath + "/" + placeholder,
        //   placeholder,
        //   "/static-media/" + placeholderPath + "/",
        //   (r: any) => {
        //     console.log(r);
        //   }
        // )
      }
    
      saveImageText(imageIndex: number, value: string) {
        let index = this.getTemplateIndex('images');
        this.template[index].data.required[imageIndex].text = value;
    
        if (this.template[index].data.required[imageIndex].tag == undefined) {
          this.template[index].data.required[imageIndex].tag = (Math.random() * 100).toString().slice(0, 5) + "-" + value;
        }
    
        this.save();
      }
    
      addRequiredImage(text: string) {
        if (text == '') return;

        let index = this.getTemplateIndex('images');
    
        // prevent adding where has same text
        let dontAdd = false;
        for (let check of this.template[index].data.required) {
          if (check.text.toLowerCase() == text.toLowerCase()) {
            dontAdd = true;
          }
        }
    
        if (!dontAdd) {
          this.template[index].data.required.push({
            text: text,
            placeholder: null,
            tag: (Math.random() * 100).toString().slice(0, 5) + "-" + text
          });
    
          this.save();
        }
      }
    
      deleteRequiredImage(removeIndex: number) {       
        let index = this.getTemplateIndex('images');
        this.template[index].data.required.splice(removeIndex, 1);
        this.save();
      }
    
      categoryLookupDate = {
        required: [],
        recommended: [],
        optional: []
      };
    
      lookupSpecifics(category: number) {
        this.ebayService.itemSpecifics(category).subscribe((r: any) => {
          this.categoryLookupDate = r.response;
        });
      }
    
      copyToClipboard(text: string) {
        this.clipboard.copy(text);
      }
    
      getParent(template: any) {
        if (template == undefined) return "";
      
        if (template.parent !== undefined) {
          return template.parent
        }
    
        return "";
      }
    
      saveParent(parent: string) {
        this.template.parent = parent;
        this.save();
      }
    
      delete() {
        this.inventoryService.deleteItemTemplate(this.template).subscribe(r => {
          this.router.navigate(['settings', 'item-template-editor'])
        });
      }

      archiveCategory() {
        this.inventoryCategoryService.archive(this.category.id).subscribe((r) => {
          this.router.navigate(["inventory"])
        })
      }
    
    }
    
    function array_move(arr, old_index, new_index) {
      if (new_index >= arr.length) {
          var k = new_index - arr.length + 1;
          while (k--) {
              arr.push(undefined);
          }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
      return arr; // for testing
    };
